exports.formatDuration = (minutes) => {
  if (!minutes) {
    return '--';
  }

  const hours = Math.floor(minutes / 60);
  const leftoverMinutes = minutes % 60;

  let retVal = '';
  if (hours > 0) {
    retVal += `${hours}hr`;
  }

  if (leftoverMinutes > 0) {
    retVal += ` ${leftoverMinutes}min`;
  }

  return retVal.trim();
};

exports.formatCurrency = (num, showCreditText, showParenthesisForNegativeAmount = true) => {
  if (!num) {
    return '$0.00';
  }

  let thousandFormattedNumber = Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(num);

  if (num < 0) {
    thousandFormattedNumber = thousandFormattedNumber.substring(1);
    if (showCreditText) {
      return `Account credit - ${thousandFormattedNumber}`;
    }

    return showParenthesisForNegativeAmount ? `(${thousandFormattedNumber})` : `-${thousandFormattedNumber}`;
  } else {
    return thousandFormattedNumber;
  }
};

exports.formatNumber = (num, decimal = 0) => {
  if (!num) {
    return 0;
  }
  if (num < 0) {
    num = Number(num) * -1;
    return `(-${num.toFixed(decimal).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')})`;
  } else {
    num = Number(num);
    return `${num.toFixed(decimal).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}`;
  }
};

exports.getLongDateString = (date) => {
  const options = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };
  return date.toLocaleString('en-Us', options);
};

exports.convertProcedurePatterntoMinutes = (pattern) => {
  return pattern.length * 10;
};

exports.convertAppointmentPatterntoMinutes = (pattern) => {
  return pattern.length * 5;
};

exports.formatDate = (date) => {
  const defReturn = '- -/- -/- -';
  if (!isValidDateType(date)) {
    return defReturn;
  }

  const formattedDate = new Date(date).toLocaleDateString('en-us');
  return (formattedDate !== 'Invalid Date') ? formattedDate : defReturn;
};

exports.formatDateAndTime = (date) => {
  const defReturn = '- -/- -/- -';
  if (!isValidDateType(date)) {
    return defReturn;
  }

  const formattedDate = new Date(date).toLocaleString('en-us');
  return (formattedDate !== 'Invalid Date') ? formattedDate : defReturn;
};

exports.formatTime = (date) => {
  const defReturn = '--:--';
  if (!isValidDateType(date)) {
    return defReturn;
  }

  const options = {
    hour: '2-digit',
    minute: '2-digit',
  };

  const timeDateObj = new Date(date);
  const formattedTime = timeDateObj.toLocaleTimeString([], options);
  return (formattedTime !== 'Invalid Date') ? formattedTime : defReturn;
};

function isValidDateType(date) {
  return (typeof (date) === 'string' || typeof (date) === 'number');
}

exports.formatPhone = (phoneNumber) => {
  const cleaned = ('' + phoneNumber)
    // replaces the plus symbol (+) followed by any single digit with 
    // an empty string for local centric phone fomatting
    // e.g. +12151231234 -> 2155121234
    .replace(/\+\d/, '')
    .replace(/[^\d^x]/g, '')
    .replace(/\s+/g, '');

  const match = cleaned.match(/^(\d{3})(\d{3})[ .-]?(\d{4})(?: *x(\d+))?\s*$/);

  if (match) {
    let ext = match[4] ? ' x' + match[4] : '';
    return '(' + match[1] + ') ' + match[2] + '-' + match[3] + ext;
  }
  return phoneNumber;
};

exports.setDefVal = (val, defVal1, defVal2) => {
  if (defVal2 !== undefined) {
    return val || val == 0 ? defVal1 : defVal2;
  } else return val !== undefined && val !== '' ? val : defVal1;
};

exports.getUsTimezones = () => {
  const tzObjArr = [
    {
      name: 'Eastern Time (ET)',
      location: 'America/New_York',
    },
    {
      name: 'Central Time (CT)',
      location: 'America/Chicago',
    },
    {
      name: 'Mountain Time (MT)',
      location: 'America/Denver',
    },
    {
      name: 'Pacific Time (PT)',
      location: 'America/Los_Angeles',
    },
  ];
  return tzObjArr;
};

exports.setAlert = (status, msg) => {
  let error = {
    text: 'There was an error',
    icon: 'mdi-alert-circle-outline',
    color: 'error',
  };
  let success = {
    text: 'success',
    icon: 'mdi-alert-circle-outline',
    color: 'success',
  };
  let info = {
    text: 'There was an error',
    icon: 'mdi-information-slab-circle-outline',
    color: 'info',
  };
  let result = (String(status) == 'fail') ? error : (status == 'success') ? success : info;
  if (msg) {
    result.text = msg;
  }
  return result;
};

exports.formatPercentage = (number) => {
  return `${(number * 100).toFixed(2)}%`;
};

exports.formatMinutes = (minutes) => {
  if (!minutes) {
    return '';
  }

  const hours = Math.floor(minutes / 60);
  const remainingMinutes = Math.floor(minutes - hours * 60);

  const hoursString = hours ? `${hours}h` : '';
  const minutesString = remainingMinutes ? `${remainingMinutes}m` : '';

  return [hoursString, minutesString].filter(Boolean).join(' ');
};

exports.prependCurrentUserRecordAndMedian = (reportDataList, medianData) => {
  let userHasRecordInReportData = false;

  for (let i = 0, l = reportDataList.length; i < l; ++i) {
    if (reportDataList[i].isCurrentUserRecord) {
      const [userRecord] = reportDataList.splice(i, 1);
      const medianRecord = {
        ...medianData,
        fullName: 'Median',
        isMedian: true,
        isActive: true,
      };

      reportDataList.unshift(userRecord, medianRecord);
      userHasRecordInReportData = true;
      break;
    }
  }

  return userHasRecordInReportData;
};
